import { MotivazioniNazioniDocument, PaginaDocument } from '@gql/graphql'
import { initializeApollo } from '@gql/client'
import { NextWrapper } from 'data-fetching-wrapper'
import LandingTemplate from '@components/templates/LandingTemplate/LandingTemplate'
import EditorialeTemplate from '@components/templates/RivenditoriTemplate/EditorialeTemplate'
import ContattaciTemplate from '@components/templates/ContattaciTemplate/ContattaciTemplate'
import AcquistiOnlineHubTemplate from '@components/templates/AcquistiOnlineHubTemplate/AcquistiOnlineHubTemplate'
import AcquistiOnlineDetailTemplate from '@components/templates/AcquistiOnlineDetailTemplate/AcquistiOnlineDetailTemplate'
import GuidaTaglieTemplate from '@components/templates/GuidaTaglieTemplate/GuidaTaglieTemplate'
import ManualiTemplate from '@components/templates/ManualiTemplate/ManualiTemplate'
import RichiestaManualiTemplate from '@components/templates/RichiestaManualiTemplate/RichiestaManualiTemplate'
import LandingNewsletterTemplate from '@components/templates/LandingNewsletterTemplate/LandingNewsletterTemplate'

const Pagina = ({ pagina, mainContent, motivazioniNazioni = undefined }) => {
  const mappingTemplateComponent = {
    landing: <LandingTemplate pagina={pagina} mainContent={mainContent} />,
    landing_newsletter: <LandingNewsletterTemplate pagina={pagina} />,
    editoriale: <EditorialeTemplate pagina={pagina} mainContent={mainContent} />,
    contattaci: (
      <ContattaciTemplate
        pagina={pagina}
        mainContent={mainContent}
        motivazioniNazioni={motivazioniNazioni}
      />
    ),
    acquisti_online_hub: <AcquistiOnlineHubTemplate pagina={pagina} mainContent={mainContent} />,
    acquisti_online_detail: (
      <AcquistiOnlineDetailTemplate pagina={pagina} mainContent={mainContent} />
    ),
    acquisti_online_guida_taglie: <GuidaTaglieTemplate pagina={pagina} />,
    ricerca_manuali: <ManualiTemplate pagina={pagina} />,
    richiedi_manuali: <RichiestaManualiTemplate pagina={pagina} />,
  }

  return (
    mappingTemplateComponent[pagina?.template] ?? (
      <EditorialeTemplate pagina={pagina} mainContent={mainContent} />
    )
  )
}

export const getStaticPaths = NextWrapper.getStaticPaths(async () => {
  return {
    paths: [],
    fallback: 'blocking',
  }
}, '/[slug]')

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ params: { slug }, preview, previewData, locale }) => {
    const client = initializeApollo(locale)

    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const route = '/' + slug.join('/')

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: {
        path: route,
        withSiblings: true,
        includeSelf: true,
        preview,
      },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    const mainContent = pagina?.pagebuilders?.find((x) => x.key === 'main') ?? null

    let motivazioniNazioniData = []

    if (pagina.template === 'contattaci') {
      const {
        data: { motivazioniNazioni },
      } = await client.query({
        query: MotivazioniNazioniDocument,
      })

      motivazioniNazioniData = motivazioniNazioni
    }

    return {
      props: {
        pagina,
        motivazioniNazioni: motivazioniNazioniData,
        mainContent,
        key: pagina.pk,
      },
      revalidate: 60 * 10,
    }
  },
  '/[slug]'
)

export default Pagina
